import React from "react";
import { useSelector } from "react-redux";
import AvatarWithInfoBox from "../Avatar/AvatarWithInfoBox";
import Lightbox from "react-image-lightbox";

const MessageContentBox = ({ id, data, isRight }) => {
  const user = useSelector((state) => state.login.profile);
  const [showLightBox, setShowLightBox] = React.useState(false);
  const [photoClicked, setPhotoClicked] = React.useState(null);

  let anexos = [];
  try {
    if (!!data?.Anexos) {
      anexos = JSON.parse(data?.Anexos);
    }
  } catch (error) {
    console.log("Não há anexos: ", data?.Anexos);
  }

  return (
    <div key={id} className="message-content-box">
      <div className="d-flex justify-content-between">
        {user?.ID_Usuario !== data?.ID_Usuario ? (
          <AvatarWithInfoBox data={data} isRight={isRight} />
        ) : (
          <div></div>
        )}
        {/* { user?.ID_Usuario !== data?.ID_Usuario ? <div className="d-flex gap-2">
          { data?.Foto_Usuario ? <div className="photo-user"> <img src={data?.Foto_Usuario} /> </div>
          : <i
              className="far fa-user-circle user-photo-label "
              style={{ fontSize: 32 }}
              aria-hidden="true"
            />
          }
          <div className="d-flex align-items-center">
            <span className="font-size-16 text-color-azul1 font-w-600">
              {data?.Nome_Completo}
            </span>
          </div>
        </div> : <div></div>} */}
        <div>
          <span className="font-size-14 text-color-cinza5 font-w-400">
            {data?.Data_Mensagem}
          </span>
        </div>
      </div>
      <div className="mt-2">
        <div
          dangerouslySetInnerHTML={{
            __html: data?.Conteudo_Mensagem?.replaceAll(
              "src=",
              "class='img-thumbnail' style='max-width: 120px' src="
            ),
          }}
        ></div>
      </div>
      {anexos.length > 0 && (
        <div className="mt-2">
          {anexos.map((anexo, index) => (
            <div key={index} className="mt-1">
              {!anexo?.Caminho_Arquivo.includes('png') && !anexo?.Caminho_Arquivo.includes('jpg') && !anexo?.Caminho_Arquivo.includes('jpeg') ? (
                <a
                  type="button"
                  download
                  style={{borderRadius: 12}}
                  className="btn bg-white border-color-cinza2 d-flex align-items-center gap-1 my-3"
                  onClick={() => {
                    window.open(anexo?.Caminho_Arquivo, "_blank");
                  }}
                >
                  <i class="fa-solid fa-file-pdf text-color-azul2 font-size-24"></i> 
                  <span className="font-size-14 font-w-600 text-color-cinza5">{`${anexo?.Nome_Arquivo}`}</span>
                </a>
              ) : (
                <img
                  onClick={() => {
                    setShowLightBox(!showLightBox);
                    setPhotoClicked(anexo?.Caminho_Arquivo || anexo);
                  }}
                  src={anexo?.Caminho_Arquivo || anexo}
                  alt={anexo?.Nome_Arquivo}
                  title={anexo?.Nome_Arquivo}
                  className="img-message-chat cursor-pointer"
                  style={{ maxWidth: 120 }}
                />
              )}
            </div>
          ))}
        </div>
      )}

      {showLightBox && (
        <div className="lightbox-view-image-custom-message">
          <Lightbox
            mainSrc={photoClicked}
            enableZoom={true}
            onCloseRequest={() => {
              setShowLightBox(!showLightBox);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default MessageContentBox;
